import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 480px;
  height: 51px;
  border-radius: 2px;
  overflow: hidden;
`;

interface TabProps {
    isActive: boolean;
    disabled?: boolean;
}

export const Tab = styled.button<TabProps>`
  width: 100%;
  height: 51px;
  cursor: pointer;
  font-family: "Baloo 2", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  transition: all 0.2s ease;
  box-sizing: border-box;
  border: 2px solid transparent;
`;